import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import MultipleChoiceQuestion from './MultipleChoiceQuestion';
import WaiverQuestion from './WaiverQuestion';
import TextQuestion from './TextQuestion';
import {
  TYPE_TEXT,
  TYPE_WAIVER,
  TYPE_ADDRESS,
  TYPE_MULTIPLE_CHOICE,
  TYPE_PHONE,
  TYPE_URL,
  TYPE_EMAIL,
  TYPE_NUMBER,
  TYPE_RANGE,
  TYPE_DATE
} from '../reducers/questions';
import { setAnswer, updateQuestion, validateQuestion } from '../actions/questions';
import { isKioskMode } from '../../../selectors/ui';
import { triggerTransition } from '@uirouter/redux';
import { initKeyboard } from 'checkout/actions/keyboard';
import Translation from '../../../../shared/Translation';
import { PhoneQuestion } from './PhoneQuestion';
import { DateQuestion } from './DateQuestion';
import LocalizedAddress from '../../member/components/LocalizedAddress';
import { getXssFilter } from '@showclix-shared-util/xssFilter';

const inputTypeMap = {
  [TYPE_TEXT]: 'text',
  [TYPE_URL]: 'url',
  [TYPE_EMAIL]: 'email',
  [TYPE_NUMBER]: 'number',
  [TYPE_RANGE]: 'number'
};

export const getInputId = (labelId) => `input-${labelId}`;

export const getErrorId = (elementId) => `error_${elementId}`;

class Question extends Component {
    constructor(props) {
      super(props);
      this.xssFilter = getXssFilter();
    }

    getProcessedQuestion = () => {
      return this.xssFilter.process(this.props.question.question);
    }

    getLegend = () => {
        return (
            <Fragment>
                <span dangerouslySetInnerHTML={{ __html: this.getProcessedQuestion() }} />
                {this.getRequiredQuestionTagElement()}
            </Fragment>
        )
    }
  
    getQuestionType() {
        const hasError = this.hasError();

        if ((this.props.question.question_type == TYPE_TEXT || this.props.question.question_type == TYPE_MULTIPLE_CHOICE) && this.props.question.options) {
            return (
                <MultipleChoiceQuestion
                    options={this.props.question.options}
                    answer={this.props.question.answer}
                    onAnswerUpdate={this.onAnswerUpdate}
                    writeIn={this.props.question.allows_write_in}
                    writeInOption={this.props.question.write_in_option}
                    question={this.props.question.question}
                    onFocus={this.onFocus}
                    selectMultiple={this.props.question.question_type == TYPE_MULTIPLE_CHOICE}
                    id={this.props.question?.question_id}
                    elementId={this.props.question?.element_id}
                    inputId={getInputId(this.props.question.element_id)}
                    legend={this.getLegend()}
                />
            );
        }

        if (this.props.question.question_type == TYPE_DATE) {
          return (
            <DateQuestion
              textQuestionValue={this.props.question.answer}
              onAnswerUpdate={this.onAnswerUpdate}
              question={this.props.question.question}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              hasError={hasError}
              inputId={getInputId(this.props.question.element_id)}
              errorId={getErrorId(this.props.question.element_id)}
            />
          )
        }

        if (this.props.question.question_type == TYPE_WAIVER) {
            let checked = false;
            if(this.props.question.answer === "1") {
                checked = true;
            } else if(this.props.question.answer === "") {
                checked = false;
            } else {
                checked = this.props.question.answer;
            }

            return (
                <WaiverQuestion
                    waiverLabel={this.props.question.options[0]}
                    waiverChecked={checked}
                    onAnswerUpdate={this.onAnswerUpdate}
                    waiver={this.props.question.waiver_text}
                    id={this.props.question.question_id}
                    elementId={this.props.question?.element_id}
                    isKioskMode={this.props.isKioskMode}
                    transitionToWaiver={this.transitionToWaiver}
                    legend={this.getLegend()}
                />
            )
        }

        if (this.props.question.question_type == TYPE_ADDRESS) {
            {/* To be replaced with the address component */ }

            return (
                <LocalizedAddress
                    {...this.props.question.address || {}}
                    onAddressChange={this.onAddressChange(this.props.question)}
                    legend={this.getLegend()}
                    nameRequired
                    zipRequired
                    cityRequired
                    stateRequired
                    countryRequired
                    addressRequired
                />
            )
        }

        if (this.props.question.question_type == TYPE_PHONE) {
            return (
                <PhoneQuestion
                    textQuestionValue={this.props.question.answer}
                    onAnswerUpdate={this.onAnswerUpdate}
                    question={this.props.question.question}
                    onFocus={this.onFocus}
                    required={Boolean(Number(this.props.question.required))}
                    onBlur={this.onBlur}
                    hasError={hasError}
                    defaultCountryCode={this.props.countryCode}
                    legend={this.getLegend()}
                    inputId={getInputId(this.props.question.element_id)}
                    elementId={this.props.question.element_id}
                    errorId={getErrorId(this.props.question.element_id)}
                />
            )
        }

        const inputType = inputTypeMap[this.props.question.question_type];

        if (inputType) {
            return (
                <TextQuestion
                    textQuestionValue={this.props.question.answer}
                    onAnswerUpdate={this.onAnswerUpdate}
                    question={this.props.question.question}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    type={inputType}
                    hasError={hasError}
                    inputId={getInputId(this.props.question.element_id)}
                    errorId={getErrorId(this.props.question.element_id)}
                />
            )
        }
  }

  onAddressChange = question => address => {
    for (const key in this.props.address) {
      if (this.props.address[key] !== '' && address[key] === '') {
        address[key] = question.address[key];
      }
    }

    this.props.updateQuestion(
      question.resource_id,
      question.answer_resource_id,
      this.props.question.answer_resource_type,
      'address',
      address
    );
  };

  onFocus = (e, label) => {
    this.props.initKeyboard(e.target, label, setAnswer, 'text', [
      this.props.question.resource_id,
      this.props.question.answer_resource_id,
      this.props.question.answer_resource_type
    ]);
  };

  onBlur = () => {
    this.props.validateQuestion(this.props.question);
  };

  clearError = () => {
    this.props.updateQuestion(
      this.props.question.resource_id,
      this.props.question.answer_resource_id,
      this.props.question.answer_resource_type,
      'error',
      undefined
    );
  };

  hasError = () => {
    return !!this.props.question.error?.message;
  };

  getErrorComponent = () => {
    const { error } = this.props.question;

    if (!error?.message) return null;

    return (
      <p
        id={getErrorId(this.props.question.element_id)}
        className="input--error__text"
        role="alert"
        aria-live="polite"
        aria-describedby={this.props.question.element_id}
      >
        <Translation interpolation={error.interpolation}>{error.message}</Translation>
      </p>
    );
  };

  onAnswerUpdate = val => {
    this.props.setAnswer(
      this.props.question.resource_id,
      this.props.question.answer_resource_id,
      this.props.question.answer_resource_type,
      val
    );

    this.props.validateQuestion(this.props.question, val);
  };

  transitionToWaiver = () => {
    this.props.triggerTransition('kioskWaiverView', { token: this.props.token, question: this.props.question });
  };

  getRequiredQuestionTagElement = () => {
    if (parseInt(this.props.question.required)) {
      return (
        <span className="input__required">
          <Translation>{'checkout__required'}</Translation>
        </span>
      );
    }
  }

  getRequiredQuestionTag() {
    if (this.props.question.question_type === TYPE_MULTIPLE_CHOICE ||
      this.props.question.question_type === TYPE_ADDRESS ||
      this.props.question.question_type === TYPE_PHONE ||
      (this.props.question.question_type === TYPE_WAIVER && !this.props.isKioskMode)) {
      return;
    }

    return this.getRequiredQuestionTagElement()
  }

  getQuestion() {
    if (this.props.question.question_type === TYPE_MULTIPLE_CHOICE ||
      this.props.question.question_type === TYPE_ADDRESS ||
      this.props.question.question_type === TYPE_PHONE ||
      (this.props.question.question_type === TYPE_WAIVER && !this.props.isKioskMode)) {
      return;
    }

    if (this.props.question.question) {
      return (
        <label
          className="input__label question__label"
          id={this.props.question.element_id}
          htmlFor={getInputId(this.props.question.element_id)}
        >
          <div dangerouslySetInnerHTML={{ __html: this.getProcessedQuestion() }} />
        </label>
      );
    }
  }

  render() {
    return (
      <div className="input__question">
        <div className="input__top">
          {this.getQuestion()}
          {this.getRequiredQuestionTag()}
        </div>
        {this.getQuestionType()}
        {this.getErrorComponent()}
      </div>
    );
  }
}

Question.propTypes = {
  question: PropTypes.object,
  isKioskMode: PropTypes.bool,
  token: PropTypes.string,
  countryCode: PropTypes.string
};

const mapStateToProps = state => {
  return {
    token: state.reservation.token,
    countryCode: state.reservation.country_phone_code,
    isKioskMode: isKioskMode(state)
  };
};
const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setAnswer,
      updateQuestion,
      triggerTransition,
      initKeyboard,
      validateQuestion
    },
    dispatch
  );
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Question);
